<template>
  <div id="editorial-office-submissions-review-result">
    <div class="ipub-h1 mar-b-10 relative">
      Reviews and Comments for Manuscript No: {{detail.code}}
      <div class="right-option ipub-p1">
        <ipub-button @click="()=>{$router.back(-1)}"
                     plain
                     type="primary"
                     style="width:100px">Back</ipub-button>
      </div>
    </div>
    <div class="mar-b-10 ipub-h2">
      Version {{detail.sign}} Reviewer Report
    </div>
    <div class="review-result-current mar-b-10">
      <div class="review-result-current-item content-bg"
           v-for="(item, index) in detail.reviewerList"
           :key="'reviewerList'+index">
        <div class="ipub-p2 line-h-40 ipub-title-tab"
             style="min-height:40px;height:auto;">
          <template v-if="item.seq">Reviewer {{item.seq}}: </template> {{item.firstName}} {{item.lastName}}({{item.email}})
        </div>
        <div class="ipub-title-tab-part">
          <div :class="['ipub-p2 line-h-40 font-color', detail.sign===val.sign?'border-bottom':'']"
               v-for="val in item.reviewerSignList"
               :key="val.id">
            <ipub-label size="small"
                        cover
                        style="padding:0 5px"
                        type="warning">
              V{{val.sign}}
            </ipub-label>
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS')">
              <a class="link-color mar-l-10"
                 @click="showReport(val)">{{REVIEWER_DECISION[val.decisionStatus]}}</a>
            </template>
            <template v-else>
              <span class="link-color mar-l-10">{{REVIEWER_DECISION[val.decisionStatus]}}</span>
            </template>

          </div>
        </div>
      </div>
    </div>
    <div class="ipub-h2 mar-b-10">Reviewer Report History</div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:name="{record}">
          {{record.firstName}} {{record.lastName}}
          <template v-if="record.seq">(Reviewer {{record.seq}})</template>
        </template>
        <template v-slot:email="{text}">
          <a class="link-color"
             :href="'mailto:'+text">{{text}}</a>
        </template>
        <template v-slot:status="{record,text}">
          <template v-if="text">
            <div style="width:12px;height:12px;border-radius:6px"
                 :class="'ipub-decision-count-item--'+text"></div>
            <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS')">
              <a class="link-color mar-l-10"
                 @click="showReport(record)">{{REVIEWER_DECISION[text]}}</a>
            </template>
            <template v-else>
              <span class="link-color mar-l-10">{{REVIEWER_DECISION[text]}}</span>
            </template>
          </template>
          <template v-else>- -</template>
        </template>
      </ipub-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
